import {
  alpha,
  darken as muiDarken,
  getContrastRatio as muiGetContrastRatio,
  lighten as muiLighten,
} from '@mui/material/styles';

export { alpha };

export const darken = (color: string, coefficient: number): string => muiDarken(color, coefficient);

export const lighten = (color: string, coefficient: number): string =>
  muiLighten(color, coefficient);

export const getContrastRatio = (foreground: string, background: string): number =>
  muiGetContrastRatio(foreground, background);
